import { TypographyName } from '@doveit/bricks';
import dynamic from 'next/dynamic';
import React, { FunctionComponent, useCallback } from 'react';
import PageSection from '../../../components/page-section/PageSection';
import { sendEvent } from '../../../services/tracking/tracking';
import { sendEvaluationLeadSubmitEventAndRedirect } from '../../../utils/tracking';

export interface EvaluationLeadWizardBlockProps {
  title: string,
  description: string,
}

const HandleEvaluationLeadWizard = dynamic(
  () => import('../../../containers/handle-evaluation-lead-wizard/HandleEvaluationLeadWizard'),
  { ssr: false },
);

const EvaluationLeadWizardBlock: FunctionComponent<EvaluationLeadWizardBlockProps> = ({
  title,
  description,
}) => {
  const onStep = useCallback((step) => {
    sendEvent('step_complete', {
      category: 'form',
      action: 'submit',
      label: `main:evaluation-lead-wizard:${step}`,
      step,
    });
  }, []);

  const onWizardComplete = useCallback((lead) => {
    sendEvaluationLeadSubmitEventAndRedirect('main:evaluation-lead-wizard', lead);
  }, []);

  return (
    <PageSection padding={[0]}>
      <PageSection.Wrapper withoutPad>
        <PageSection.Title
          content={title}
          size={TypographyName.H3}
        />
        <PageSection.Description
          text={description}
          size={TypographyName.BODY}
          color="neutrals.dark"
        />
        <PageSection.Block>
          <HandleEvaluationLeadWizard
            data-ref="evaluation-lead-wizard"
            sessionStorageKey="evaluation-lead-wizard"
            onStep={onStep}
            onWizardComplete={onWizardComplete}
          />
        </PageSection.Block>
      </PageSection.Wrapper>
    </PageSection>
  );
};

export default EvaluationLeadWizardBlock;
